const faqs = [
  {
    question: "Does Oregon have its own regional passport agency?",
    answer:
      "No, Oregon does not have a regional passport agency within the state borders. The nearest regional passport agencies for Oregon travelers are the Seattle Passport Agency in Washington and the San Francisco Passport Agency in California. Both require appointments and proof of travel within 14 days (or 28 days with a visa). Most Oregon residents find that using an approved expedited courier service is significantly faster and more convenient than traveling out of state.",
  },
  {
    question: "How fast can I get a passport in Oregon?",
    answer:
      "With Fast Passport Center's courier service, Oregon travelers can receive a passport in as little as 24 hours. Our standard expedited service ranges from 3 to 9 business days. Routine processing through the post office typically takes 6 to 13 weeks.",
  },
  {
    question: "Do I need to visit a passport acceptance facility in Oregon?",
    answer:
      "First-time applicants, minors, and those replacing lost or stolen passports must visit an acceptance facility (typically a post office, county clerk, or public library). Oregon has acceptance facilities throughout the state, including in Portland, Eugene, Bend, Medford, and many smaller communities. Renewals for adults can usually be done by mail without an in-person visit.",
  },
  {
    question: "Which Oregon airport should I fly from with an expired passport?",
    answer:
      "If your passport is expired or soon to expire, you should not book international travel until you have a valid passport in hand. Major Oregon airports with international connections include Portland International (PDX), Eugene (EUG), Medford (MFR), and Redmond (RDM). PDX offers the most direct international flights.",
  },
  {
    question: "Can I renew by mail from Oregon?",
    answer:
      "Yes, if your most recent passport was issued when you were 16 or older, is undamaged, was issued within the last 15 years, and was issued in your current name (or you have legal documentation of a name change), you can renew by mail from any Oregon address. Use Form DS-82 and include a new passport photo.",
  },
  {
    question: "Where is the best place to get a passport photo in Oregon?",
    answer:
      "CVS, Walgreens, UPS Store, FedEx Office, and Walmart all offer passport photos at locations throughout Oregon. In Portland, most chain stores have reliable photo services. For rural areas, many local pharmacies and photography studios can also take compliant passport photos. Always verify the photo meets official requirements before submitting.",
  },
];

export { faqs };

export default function OregonFAQSection() {
  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Oregon Passport Questions
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Quick answers for travelers applying for passports across the state of Oregon.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-white rounded-lg border border-gray-200 overflow-hidden"
            >
              <summary className="flex items-center justify-between cursor-pointer p-5 list-none">
                <span className="font-bold text-[#1A365D] text-sm pr-4">{faq.question}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-add-line text-[#1A365D] text-sm group-open:ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}